import { message } from 'antd';
import { put, takeLatest } from 'redux-saga/effects';
import { logger } from 'services';
import { shiftStartDayOfProjectPhaseInProjectTemplate } from '../../actions';
import { shiftStartDayOfProjectPhase } from '../../slices';
function* shiftStartDayProjectPhaseInProjectTemplateSaga({ payload: { projectPhaseId, shiftBy } }) {
    try {
        yield put(shiftStartDayOfProjectPhase({
            projectPhaseId,
            shiftBy
        }));
    } catch (error) {
        logger.error('Error in shifting the start day of the phase', {
            error
        });
        message.error('There was an error while shifting the start day');
    }
}
export function* watchShiftStartDayOfProjectPhaseInProjectTemplateSaga() {
    yield takeLatest(shiftStartDayOfProjectPhaseInProjectTemplate.type, shiftStartDayProjectPhaseInProjectTemplateSaga);
}
